export const initialState = {
    basic: {
        name: '',
        category: 'カスタム',
        description: '',
        systemPrompt: '',
        userPromptTemplate: 'ユーザーからの質問: {user_input}\n\n上記の質問について回答してください。',
        model: 'gpt-4o-mini',
        temperature: 0.7,
        createdBy: 'admin',
    },
    ragMcp: {
        availableCollections: [],
        selectedCollections: [],
        ragLoading: false,
        showCreateCollection: false,
        newCollectionName: '',
        newCollectionDescription: '',
        selectedFiles: [],
        creatingCollection: false,
        availableTools: [],
        availableToolGroups: [],
        selectedToolGroups: [],
        selectedTools: [],
        mcpLoading: false,
        hasE3SmartToken: false,
        e3smartAuthLoading: false,
        hasMcpServerTokens: {},
        mcpServerEnabled: {},
        mcpServerAuthLoading: false,
    },
    availableLLMs: [],
    llmsLoading: false,
    ui: {
        submitting: false,
        error: '',
        success: '',
        showPromptPreview: false,
        promptPreview: '',
        showAdvancedFeatures: false,
        showEndpointSettings: false,
        showAISettings: false,
        showTagManagement: false,
        showParameterSettings: false,
        showCustomHeaders: false,
        showCustomEndpointDetails: false,
        showPublicSettings: false,
    },
    advanced: {
        customEndpointPath: '',
        endpointValidation: { isValid: true, message: '' },
        parameters: [],
        customHeaders: [],
        tags: [],
        newTagInput: '',
        maxTokens: 4000,
        responseTimeout: 30,
        method: 'POST',
    },
    auth: {
        authRequired: false,
        authType: 'none',
        authToken: '',
        authHeader: '',
        requestTimeout: 30000,
        retryCount: 3,
    },
    // 公開設定初期値（デフォルト: プライベート）
    public: {
        isPublic: false,
        publicVisibility: 'private',
        allowedTenants: [],
        allowedUsers: [],
        requiresApproval: false,
        maxUsagePerDay: 100,
    },
};
// Reducer関数
export const modalReducer = (state, action) => {
    switch (action.type) {
        case 'SET_BASIC_CONFIG':
            return {
                ...state,
                basic: { ...state.basic, ...action.payload }
            };
        case 'SET_RAG_MCP_CONFIG':
            return {
                ...state,
                ragMcp: { ...state.ragMcp, ...action.payload }
            };
        case 'SET_UI_STATE':
            return {
                ...state,
                ui: { ...state.ui, ...action.payload }
            };
        case 'SET_ADVANCED_CONFIG':
            return {
                ...state,
                advanced: { ...state.advanced, ...action.payload }
            };
        case 'SET_AUTH_CONFIG':
            return {
                ...state,
                auth: { ...state.auth, ...action.payload }
            };
        case 'SET_PUBLIC_CONFIG':
            return {
                ...state,
                public: { ...state.public, ...action.payload }
            };
        case 'SET_AVAILABLE_LLMS':
            return {
                ...state,
                availableLLMs: action.payload
            };
        case 'SET_LLMS_LOADING':
            return {
                ...state,
                llmsLoading: action.payload
            };
        case 'RESET_ALL_STATE':
            return initialState;
        case 'LOAD_AGENT_DATA':
            const agent = action.payload;
            const agentConfig = agent.config || {};
            const selectedModel = agentConfig.llm_config?.model || agentConfig.llm_config?.model_name || agent.diveModel || 'gpt-4o-mini';
            return {
                ...state, // 既存の状態を保持（availableLLMs等を保持）
                basic: {
                    ...initialState.basic,
                    name: agent.name || '',
                    category: agent.category || 'カスタム',
                    description: agentConfig.description || agent.description || '',
                    systemPrompt: agentConfig.system_prompt || agent.systemPrompt || '',
                    userPromptTemplate: agentConfig.user_prompt_template || agent.userPromptTemplate || 'ユーザーからの質問: {user_input}\n\n上記の質問について回答してください。',
                    model: selectedModel,
                    temperature: agentConfig.llm_config?.temperature || agent.diveTemperature || 0.7,
                    createdBy: agent.diveCreatedBy || 'admin',
                },
                advanced: {
                    ...initialState.advanced,
                    customEndpointPath: (agent.customEndpointPath || agent.endpointPath || '').replace(/^\/api\/custom\//, '').replace(/^\//, ''),
                    parameters: agent.parameters || [],
                    customHeaders: agent.customHeaders || [],
                    tags: agent.tags || [],
                    maxTokens: agent.maxTokens || 4000,
                    responseTimeout: agent.responseTimeout || 30,
                    method: agent.method || 'POST',
                },
                auth: {
                    ...initialState.auth,
                    authRequired: agent.authRequired || false,
                    authType: agent.authType || 'none',
                    authToken: agent.authToken || '',
                    authHeader: agent.authHeader || '',
                    requestTimeout: agent.requestTimeout || 30000,
                    retryCount: agent.retryCount || 3,
                },
                public: {
                    ...initialState.public,
                    isPublic: agent.isPublic || false,
                    publicVisibility: agent.publicVisibility || 'private',
                    allowedTenants: agent.accessControl?.allowedTenants || [],
                    allowedUsers: agent.accessControl?.allowedUsers || [],
                    requiresApproval: agent.accessControl?.requiresApproval || false,
                    maxUsagePerDay: agent.accessControl?.maxUsagePerDay || 100,
                },
                // RAG/MCP設定ロード
                ragMcp: {
                    ...initialState.ragMcp,
                    availableCollections: state.ragMcp.availableCollections,
                    availableTools: state.ragMcp.availableTools,
                    availableToolGroups: state.ragMcp.availableToolGroups,
                    hasE3SmartToken: state.ragMcp.hasE3SmartToken,
                    selectedCollections: agent.selectedCollections || [],
                    selectedToolGroups: (() => {
                        // config.mcp_serversから selectedToolGroups を復元
                        const mcpServers = agentConfig.mcp_servers;
                        if (mcpServers && typeof mcpServers === 'object') {
                            return Object.keys(mcpServers);
                        }
                        return [];
                    })(),
                    selectedTools: agent.selectedTools || [],
                },
            };
        default:
            return state;
    }
};
// useReducer初期化関数: useEffect不要で編集データロード
export const initializeModalState = (props) => {
    if (props.mode === 'edit' && props.agentData) {
        const agent = props.agentData;
        const agentConfig = agent.config || {};
        const selectedModel = agentConfig.llm_config?.model || agentConfig.llm_config?.model_name || agent.diveModel || 'gpt-4o-mini';
        return {
            ...initialState, // ベース初期状態
            basic: {
                ...initialState.basic,
                name: agent.name || '',
                category: agent.category || 'カスタム',
                description: agentConfig.description || agent.description || '',
                systemPrompt: agentConfig.system_prompt || agent.systemPrompt || '',
                userPromptTemplate: agentConfig.user_prompt_template || agent.userPromptTemplate || 'ユーザーからの質問: {user_input}\n\n上記の質問について回答してください。',
                model: selectedModel,
                temperature: agentConfig.llm_config?.temperature || agent.diveTemperature || 0.7,
                createdBy: agent.diveCreatedBy || 'admin',
            },
            advanced: {
                ...initialState.advanced,
                customEndpointPath: agent.customEndpointPath || agent.endpointPath || '',
                parameters: agent.parameters || [],
                customHeaders: agent.customHeaders || [],
                tags: agent.tags || [],
                maxTokens: agent.maxTokens || 4000,
                responseTimeout: agent.responseTimeout || 30,
                method: agent.method || 'POST',
            },
            auth: {
                ...initialState.auth,
                authRequired: agent.authRequired || false,
                authType: agent.authType || 'none',
                authToken: agent.authToken || '',
                authHeader: agent.authHeader || '',
                requestTimeout: agent.requestTimeout || 30000,
                retryCount: agent.retryCount || 3,
            },
            public: {
                ...initialState.public,
                isPublic: agent.isPublic || false,
                publicVisibility: agent.publicVisibility || 'private',
                allowedTenants: agent.accessControl?.allowedTenants || [],
                allowedUsers: agent.accessControl?.allowedUsers || [],
                requiresApproval: agent.accessControl?.requiresApproval || false,
                maxUsagePerDay: agent.accessControl?.maxUsagePerDay || 100,
            },
            // RAG/MCP設定ロード
            ragMcp: {
                ...initialState.ragMcp,
                selectedCollections: agent.selectedCollections || [],
                selectedToolGroups: (() => {
                    // config.mcp_serversから selectedToolGroups を復元
                    const mcpServers = agentConfig.mcp_servers;
                    if (mcpServers && typeof mcpServers === 'object') {
                        return Object.keys(mcpServers);
                    }
                    return [];
                })(),
                selectedTools: agent.selectedTools || [],
            },
        };
    }
    return initialState;
};
